import Cursor from "./Cursor";
import { FaWhatsapp } from "react-icons/fa";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TopBar from "./Components/TopBar";
import NavBar from "./Components/NavBar";
import Footer from "./Components/Footer";
import ServicesPage from "./Pages/ServicesPage";
import BlogDetail from "./Pages/BlogDetail";
import Request from "./Pages/Request";
import ServiceDetail from "./Pages/ServiceDetail";
// Pages
import Home from "./Pages/Home";
import About from "./Pages/About";
import Services from "./Pages/Services";
import Courses from "./Pages/Courses";
import Blogs from "./Pages/Blogs";
import Contact from "./Pages/Contact";
import Carrer from "./Pages/Carrer";
import TechStack from "./Pages/TechStack";
import Meeting from "./Pages/Meeting";
function App() {
  return (
    <Router>
      <Cursor /> 
      <TopBar />
      <NavBar />

 <div className="pt-24"> 
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/carrer" element={<Carrer />} />
       <Route path="/servicespage" element={<ServicesPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
         <Route path="/request" element={<Request/>} />
         <Route path ="/meeting" element={<Meeting/>}/>
    
      <Route path="/service/:slug" element={<ServiceDetail />} /> 
      </Routes>
      <Footer/>
         </div>
         <a
        href="https://wa.me/917814955755"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition"
      >
        <FaWhatsapp size={24} />
      </a>
    </Router>
  );
}

export default App;